var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"icon":_vm.icon,"loading":_vm.loading,"plain":_vm.plain},on:{"click":_vm.handleExport}},[_vm._v(" "+_vm._s(_vm.text || '导出数据')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }